enum CountriesZipCodeLengthEnum {
  Estonia = 5,
  Latvia = 4,
  Lithuania = 5,
}

export default CountriesZipCodeLengthEnum
